import type { ResultOf } from '@graphql-typed-document-node/core';

import Grid from '@mui/material/Grid';

import { graphql } from '@e-socna/data-layer';

import { CodeSuggest } from '../../../../components/CodeSuggest';
import type { CodeSuggestionHook } from '../../../../components/CodeSuggest/types/code-suggestion-hook.type';

export const FolderBusinessEntityForm_CodingConfigStep_Codable_Fragment =
  graphql(`
    fragment FolderBusinessEntityForm_CodingConfigStep_Codable_Fragment on Codable {
      codingConfig {
        kind
        strategyId
        ... on CodingConfigManual {
          code
        }
        ...CodeCmp_CodingConfig_Fragment
      }
      code
    }
  `);

export type FolderBusinessEntityForm_CodingConfigStep_Codable = ResultOf<
  typeof FolderBusinessEntityForm_CodingConfigStep_Codable_Fragment
>;

interface Props {
  readonly id: string;
  readonly useCodeSuggestion: CodeSuggestionHook;
}

export const FolderBusinessEntityCodingConfigFormStep = ({
  useCodeSuggestion,
}: Readonly<Props>) => (
  <Grid container spacing={2}>
    <Grid size={12}>
      <CodeSuggest useCodeSuggestion={useCodeSuggestion} />
    </Grid>
  </Grid>
);
